import React, { useState, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { BookModel } from "@/types";
import BookCard from "./BookCard";
import { Dispatch } from "@reduxjs/toolkit";
import { useNavigate } from "react-router-dom";
interface BookListProps {
  t: (key: string) => string;
  books: BookModel[];
  filteredBooks: BookModel[];
  user: any;
  dispatch: Dispatch<any>;
}

const BookList: React.FC<BookListProps> = ({ t, books, filteredBooks }) => {
  const [selectedProduct, setSelectedProduct] = useState<BookModel | null>(
    null
  );
  const bookListRef = useRef<HTMLDivElement>(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  const navigate = useNavigate();

  const handleProductClick = (product: BookModel) => {
    if (product.isGroup) {
      navigate(`/book-group/${product.id}`);
    } else {
      navigate(`/book-detail/${product.id}`);
    }
  };

  const groupBy = (xs: BookModel[], key: keyof BookModel) => {
    return xs.reduce<Record<string, BookModel[]>>((rv, x) => {
      const groupKey = x[key] as string;
      if (!rv[groupKey]) rv[groupKey] = [];
      rv[groupKey].push(x);
      return rv;
    }, {});
  };

  const renderBooks = () => {
    const groupedBooks = groupBy(
      [...filteredBooks].sort(
        (a, b) => (a.classOrder ?? 0) - (b.classOrder ?? 0)
      ),
      "classNames"
    );
    const keyNames = Object.keys(groupedBooks);
    return (
      <div>
        {keyNames.map((className) => {
          const bookList = groupedBooks[className];
          return (
            <div key={className}>
              <h3 className="class-name">{className}</h3>
              <div className="books">
                {bookList.map((book, index) => {
                  if (book.hasGroup === false) {
                    return (
                      <BookCard
                        key={`book-item-${index}`}
                        index={index}
                        book={book}
                        handleProductClick={handleProductClick}
                      />
                    );
                  }
                })}
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  if (books.length === 0) {
    return (
      <div className="no-data">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
          className="no-data-content"
        >
          <h3 className="no-data-title">{t("no_books")}</h3>
        </motion.div>
      </div>
    );
  }

  return (
    <>
      <AnimatePresence mode="wait">
        <motion.div
          className="book-list"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          <div className="grouped-books" ref={bookListRef}>
            {renderBooks()}
          </div>
        </motion.div>
      </AnimatePresence>
    </>
  );
};

export default BookList;
